import "./OurTeam.module.css";
import Header from "@/reusable_sections/Header";
import MeetYourPetSCaregivers from "./sections/MeetYourPetSCaregivers";
import JoinOurTeam from "./sections/JoinOurTeam";
import Footer from "@/reusable_sections/Footer";
export default function OurTeamPage() {
  return <div>
      <Header />
      <MeetYourPetSCaregivers />
      <JoinOurTeam />
      <Footer />
    </div>;
}